import { gql } from '@apollo/client';
import { useMutation } from '@apollo/client';

import {
  BulkCreateCabinetAssets,
  BulkCreateCabinetAssetsVariables,
} from '../../athena/types/BulkCreateCabinetAssets';

export const BULK_CREATE_CABINET_ASSETS = gql`
  mutation BulkCreateCabinetAssets(
    $assets: [OdProtosCabinetService_AssetRequests_CreateAssetInput!]
  ) {
    cabinet {
      bulkCreateUploadedAssets(input: { createAssets: $assets }) {
        assets {
          id
        }
      }
    }
  }
`;

export const useBulkCreateCabinetAssets = () =>
  useMutation<BulkCreateCabinetAssets, BulkCreateCabinetAssetsVariables>(
    BULK_CREATE_CABINET_ASSETS,
  );
